import { environment } from 'src/environments/environment';

export const MERCHANT_INSIGHTS_APIS_ENDPOINTS = {
  GET_INSIGHTS_URL: (): string => `${environment.BACKEND_URL}api/engagement/analytics`,
};
